import { Injectable } from '@angular/core';
import { HttpService } from '../../rest/http.service';
import { Observable } from 'rxjs';
import { College } from '../../models/colleges';

const routes = {
    getCounsellorData: '/getCounsellorData',
    getCounsellorDataByInstName: (name: string) =>  `/getCounsellorData?instName=${name}`,
    getStudentsCountByEthnicity:'/getStudentsCountByEthnicity',
    getStudentsCountByGender : '/getStudentsCountByGender',
    getCompletedApplicationsBySchool : '/getCompletedApplicationsBySchool',
    getStudentsEligibleForFinances :'/getStudentsEligibleForFinances',
    generateCounsellorReport:'/generateCounsellorReport',
    getTotalApplicationsCount: '/getTotalApplicationsCount',
    getApplicationsCountByMonth: '/getApplicationsCountByMonth',
    getCollegeList: '/getApplicationsCountBySchool',
    getCompletedApplicationsBySchoolPerRegion: (name: string) => name == null ? `/getCompletedApplicationsBySchoolPerRegion` : `/getCompletedApplicationsBySchoolPerRegion?region=${name}`,
    getStudentsCountByEthnicityPerRegion: (name: string) => name == null ? `/getStudentsCountByEthnicityPerRegion`: `/getStudentsCountByEthnicityPerRegion?region=${name}`,
    getStudentsCountByGenderPerRegion: (name: string) => name == null ? `/getStudentsCountByGenderPerRegion` : `/getStudentsCountByGenderPerRegion?region=${name}`,
    getCompletedApplicationsBySchoolPerProgram: (name: string) => name == null ? `/getCompletedApplicationsBySchoolPerProgram` : `/getCompletedApplicationsBySchoolPerProgram?program=${name}`,
    getStudentsCountByGenderPerProgram: (name: string) => name == null ? `/getStudentsCountByGenderPerProgram`: `/getStudentsCountByGenderPerProgram?program=${name}`,
    getStudentsCountByEthnicityPerProgram: (name: string) => name == null ? `/getStudentsCountByEthnicityPerProgram` : `/getStudentsCountByEthnicityPerProgram?program=${name}`,
    getPrograms: '/programs.json',
    getRegion: '/region.json',
    sentReport:'/sendCounselorReport'
};


@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private httpService : HttpService) { }

  getCompletedApplicationsBySchoolPerRegion(region:string) : Observable<any> {
    return this.httpService.get(routes.getCompletedApplicationsBySchoolPerRegion(region));
  }

  getStudentsCountByEthnicityPerRegion(region:string) : Observable<any> {
    return this.httpService.get(routes.getStudentsCountByEthnicityPerRegion(region));
  }

  getStudentsCountByGenderPerRegion(region:string) : Observable<any> {
    return this.httpService.get(routes.getStudentsCountByGenderPerRegion(region));
  }

  getCompletedApplicationsBySchoolPerProgram(program:string) : Observable<any> {
    return this.httpService.get(routes.getCompletedApplicationsBySchoolPerProgram(program));
  }

  getStudentsCountByGenderPerProgram(program:string) : Observable<any> {
    return this.httpService.get(routes.getStudentsCountByGenderPerProgram(program));
  }

  getStudentsCountByEthnicityPerProgram(program:string) : Observable<any> {
    return this.httpService.get(routes.getStudentsCountByEthnicityPerProgram(program));
  }

  get(name : string) : Observable<any> {
    let url : string = routes.getCounsellorData;
    if (name != undefined && name.length > 0)
        url = routes.getCounsellorDataByInstName(name);
		return this.httpService.get(url);
  }

  getPrograms() : Observable<any> {
    return this.httpService.getMock(routes.getPrograms);
  }

  getTotalApplicationsCount(name : string) : Observable<any> {
    let url = routes.getTotalApplicationsCount;
    if (name != undefined && name.length > 0)
        url += '?instName='+name;
	  return this.httpService.get(url);
  }


  getStudentsCountByEthnicity(name : string) : Observable<any> {
    let url = routes.getStudentsCountByEthnicity;
    if (name != undefined && name.length > 0)
        url += '?instName='+name;
	  return this.httpService.get(url);
  }

  getStudentsCountByGender(name : string) : Observable<any> {
    let url = routes.getStudentsCountByGender;
    if (name != undefined && name.length > 0)
        url += '?instName='+name;
	  return this.httpService.get(url);
  }

  getCompletedApplicationsBySchool(name : string): Observable<any> {
    let url = routes.getCompletedApplicationsBySchool;
    if (name != undefined && name.length > 0)
        url += '?instName='+name;
	  return this.httpService.get(url);
  }

  getApplicationsCountByMonth(name : string): Observable<any> {
    let url = routes.getApplicationsCountByMonth;
    if (name != undefined && name.length > 0)
        url += '?instName='+name;
	  return this.httpService.get(url);
  }

  generateCounsellorReport(instname : string, insttype:string): Observable<any> {
    let url = routes.generateCounsellorReport;
    if (instname != undefined && instname.length > 0)
        url += '?instName='+instname;
    if (instname != undefined && instname.length > 0 && insttype != undefined && insttype.length > 0)
        url += '&reportType='+insttype;
    else if(insttype != undefined && insttype.length > 0)
        url += '?reportType='+insttype;

	  return this.httpService.getDownloadData(url);
  }

  getStudentsEligibleForFinances() : Observable<any> {
	  return this.httpService.get(routes.getStudentsEligibleForFinances);
  }

  getCollege() : Observable<College> {
    return this.httpService.get(routes.getCollegeList);
  }

  getRegions() : Observable<College> {
    return this.httpService.getMock(routes.getRegion);
  }
  sendCounselorReport(email:string,comment:string,instName:string): Observable<College> {
    const url=routes.sentReport+'?emailId='+email+'&comment='+comment+'&instName='+instName;
      return this.httpService.get(url);
    
  }
  
}
